import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  radio: {
    color: theme.palette.primary.main,
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  fontText: {
    color: grey[800],
    fontSize: "15px",
    fontWeight: 700,
    overflowWrap: "anywhere",
  },
  fontPlayball: {
    fontFamily: "Playball !important",
  },
  fontNoteworthy: {
    fontFamily: "Noteworthy !important",
  },
  fontMarckScript: {
    fontFamily: "Marck Script !important",
  },
  fontSofia: {
    fontFamily: "Sofia !important",
  },
}));
